import Header from "components/Header";
import { useSelector } from "react-redux";
import { RootState } from "redux/rootReducer";
import QuickDonate from "components/QuickDonate/QuickDonate";
import QuickDonatePopUp from "components/QuickDonate/QuickDonatePopUp";
import MainTitle from "components/MainTitle";
import Footer from "components/Footer";
import { useTranslation } from "react-i18next";

const TermsConditions = () => {
  const { t, i18n } = useTranslation();
  const { quickDonateStatus } = useSelector(
    (state: RootState) => state.setQuickDonatePopStateReducer
  );

  return (
    <>
      <Header />

      <main className="relative w-full">
        {/* quick donate ***************************/}
        <QuickDonate />

        {/* quick donate popup  ********************/}
        {quickDonateStatus && <QuickDonatePopUp />}

        {/* main header section  *******************/}
        <MainTitle title={t("Terms and Conditions")} />

        {/* terms and conditions  ******************/}
        <section className="my-[100px]">
          <div className="mainContainer w-full px-[40px] lg:px-0 flex flex-col gap-[20px]">
            {/* part  */}
            <div>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                {t(
                  "Use of the AL Etihad Charity Foundation website constitutes acceptance of the terms and conditions contained in this document without restriction or condition, which are as follows:"
                )}
              </p>
            </div>

            {/* First  */}
            <div
              data-aos="fade-up"
              data-aos-duration="900"
              className="flex flex-col gap-3"
            >
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[700] text-[20px] text-[#444444] text-center `}
              >
                {t("First: Terms of Use:")}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                &minus;{" "}
                {t(
                  "- The use of the site may be stopped, prevented, or terminated in the event of a violation by one of the users, or if there are reasons to believe that one of the users has violated and breached the terms and rules of use."
                )}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                &minus;{" "}
                {t(
                  "- The user is prohibited from violating or attempting to violate the procedures and systems in force to protect the site, including:"
                )}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left pl-[20px]"
                    : "Almarai lg:text-right pr-[20px]"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                &bull;{" "}
                {t(
                  "Attempting to conduct a test, survey, or examination for the possibility of infecting weak points in the system or network of the AL Etihad Charity Foundation or violating the integrity of the procedures, or documenting them without an official permit from the AL Etihad Charity Foundation."
                )}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left pl-[20px]"
                    : "Almarai lg:text-right pr-[20px]"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                &bull;{" "}
                {t(
                  "Attempting to interfere with the service provided to any user, for example: by placing a virus on the site or increasing the load on it or flooding it with emails or destroying it."
                )}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left pl-[20px]"
                    : "Almarai lg:text-right pr-[20px]"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                &bull;{" "}
                {t(
                  "Sending unwanted emails to the site, including advertising, advertising products or services, or forging any email address or part of the address information in any email or sending newsgroup messages."
                )}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left pl-[20px]"
                    : "Almarai lg:text-right pr-[20px]"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                &bull;{" "}
                {t(
                  "Using the AL Etihad Charity Foundation website in any way to send an email or on its behalf or by referring to it or impersonating its name or capacity and including insulting or defaming the AL Etihad Charity Foundation or the website or any person, or announcing incorrect news or information and attributing it to the Foundation without right."
                )}
              </p>

              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                &minus;{" "}
                {t(
                  "- Violating the rules of use and violating the system or network exposes the violator to civil and criminal liability. Cases that may involve such violations and breaches will be investigated directly and the person responsible will be prosecuted."
                )}
              </p>
            </div>

            {/* Second  */}
            <div
              data-aos="fade-up"
              data-aos-duration="900"
              className="flex flex-col gap-3"
            >
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[700] text-[20px] text-[#444444] text-center `}
              >
                {t("Second: Copyright:")}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                &minus;{" "}
                {t(
                  "All rights, including copyright and database rights, in the Al Etihad Charity Foundation website and its contents are owned by the Foundation, licensed in its name, or used by it, in accordance with what is permitted by applicable laws."
                )}
              </p>
            </div>

            {/* Third  */}
            <div
              data-aos="fade-up"
              data-aos-duration="900"
              className="flex flex-col gap-3"
            >
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[700] text-[20px] text-[#444444] text-center `}
              >
                {t("Third: Intellectual Property Rights:")}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                &minus;{" "}
                {t(
                  "- The user acknowledges and agrees that all content and materials available and displayed on this site are protected by laws governing copyright, trade secrets and other intellectual property rights, except as expressly permitted by the Al Etihad Charity Foundation. The user agrees not to broadcast, display, perform, publish, modify, edit or create any derivative works from such materials or content."
                )}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                &minus;{" "}
                {t(
                  "- The user may print or download a copy of the materials or content on this site, on any personal computer for his personal use or for non-commercial use, provided that he maintains all copyright and other proprietary rights unchanged, and it is prohibited to retrieve data or any other content in an organized manner from this site to create or compile a collection, collection, database or directory without written permission from the Foundation."
                )}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                &minus;{" "}
                {t(
                  "- It is prohibited to use the content or materials published on this site for any purpose not expressly permitted under the terms of use."
                )}
              </p>
            </div>

            {/* Fourth  */}
            <div
              data-aos="fade-up"
              data-aos-duration="900"
              className="flex flex-col gap-3"
            >
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[700] text-[20px] text-[#444444] text-center `}
              >
                {t("Fourth: Disclaimer:")}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                &minus;{" "}
                {t(
                  "- In no event or under any circumstances shall the Al Etihad Charity Foundation be liable for any direct, indirect, incidental, consequential, special or exceptional damages arising from the use or inability to use this site. This condition applies whether the alleged liability is contractual, tortious, negligent or any other form of legal liability."
                )}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                &minus;{" "}
                {t(
                  "- In the event of a service interruption due to force majeure, the Al Etihad Charity Foundation shall not be liable for such malfunctions or any damages related thereto."
                )}
              </p>
            </div>

            {/* Fifth  */}
            <div
              data-aos="fade-up"
              data-aos-duration="900"
              className="flex flex-col gap-3"
            >
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[700] text-[20px] text-[#444444] text-center `}
              >
                {t("Fifth: Prevailing laws and regulations:")}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                &minus;{" "}
                {t(
                  "- Any dispute or claim arising out of or in connection with this site shall be subject to and construed in accordance with the laws of the United Arab Emirates and the competent courts in the country."
                )}
              </p>
            </div>

            {/* Sixth  */}
            <div
              data-aos="fade-up"
              data-aos-duration="900"
              className="flex flex-col gap-3"
            >
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[700] text-[20px] text-[#444444] text-center `}
              >
                {t("Sixth: Delivery Policy / Shipping Policy:")}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                &minus;{" "}
                {t(
                  "- No physical products or materials are offered or displayed on the site and therefore there are no policies regarding delivery and shipping."
                )}
              </p>
            </div>

            {/* Seventh  */}
            <div
              data-aos="fade-up"
              data-aos-duration="900"
              className="flex flex-col gap-3"
            >
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[700] text-[20px] text-[#444444] text-center `}
              >
                {t(
                  "Seventh: Payment methods, types of accepted cards and currency:"
                )}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                &minus;{" "}
                {t(
                  "- All types of Visa and Master cards are accepted and donations are made in Emirati Dirhams."
                )}
              </p>
            </div>

            {/* Eighth  */}
            <div
              data-aos="fade-up"
              data-aos-duration="900"
              className="flex flex-col gap-3"
            >
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[700] text-[20px] text-[#444444] text-center `}
              >
                {t("Eighth: Refund Policy:")}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                &minus;{" "}
                {t(
                  "- In the event that the donor wishes to withdraw the donation made through his credit card, the refund policy of the Al Etihad Charity Foundation stipulates the right of the donor to recover the full amount donated if he so desires."
                )}
              </p>
            </div>

            {/* Ninth  */}
            <div
              data-aos="fade-up"
              data-aos-duration="900"
              className="flex flex-col gap-3"
            >
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[700] text-[20px] text-[#444444] text-center `}
              >
                {t("Ninth: Review and update:")}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                &minus;{" "}
                {t(
                  "- The Al Etihad Charity Foundation reserves the right to update and change these terms and conditions at any time and is committed to announcing any amendment or change to these terms and conditions on its website."
                )}
              </p>
              <p
                className={`font-${
                  i18n.language === "en"
                    ? "Poppins lg:text-left"
                    : "Almarai lg:text-right"
                } font-[400] text-[16px] text-[#444444] text-center`}
              >
                &minus;{" "}
                {t(
                  "- Your repeated use of the site after making these amendments means your acceptance of these amendments."
                )}
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default TermsConditions;
